import {
  DiscoveryListAction,
  DiscoveryListState,
} from '../types/discoveryList';
import { DiscoveryListActionTypes } from './actionTypes';

export const initialState: DiscoveryListState = {
  sort: 'claims',
  order: 'desc',
  page: 1,
  pageSize: 50,
  q: '',
};

export const discoveryListReducer = (
  state: DiscoveryListState = initialState,
  action: DiscoveryListAction
): DiscoveryListState => {
  switch (action.type) {
    case DiscoveryListActionTypes.SET_SORT:
      return { ...state, sort: action.payload as string };
    case DiscoveryListActionTypes.SET_ORDER:
      return { ...state, order: action.payload as 'asc' | 'desc' };
    case DiscoveryListActionTypes.SET_PAGE:
      return { ...state, page: action.payload as number };
    case DiscoveryListActionTypes.SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload as number };
    case DiscoveryListActionTypes.SET_SEARCH:
      return { ...state, q: action.payload as string, page: 1 };
    default:
      return state;
  }
};
